<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('payrolls')"
      :columns="columns"
      :column_search="false"
      resource_url="/staff/payroll/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("create") }}</span>
        </button>
      </template>
    </generic-table>
    <payroll-modal ref="payroll_modal" @success="refresh" />
    <payroll-detail-modal ref="payroll_detail_modal" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_date_time,
  format_date,
} from "@/utils";
import PayrollModal from "./payroll_modal/Index.vue";
import PayrollDetailModal from "./payroll_detail_modal/Index.vue";
import { truncate } from "lodash";

export default {
  name: "StaffPayrollDatatable",
  components: { GenericTable, PayrollModal, PayrollDetailModal },
  props: {},
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("create date"),
          data: (row) => {
            return `<div class="subtitle is-6 mb-0">
                      <span class="icon"><i class="fa fa-calendar"></i></span>
                      ${format_date_time(row.create_date) || ""}
                    </div>`;
          },
        },
        {
          title: v.$t("name"),
          data: (row) => {
            let status_class = "is-dark";
            let status_icon = "fa fa-question";
            if (row.status === "pending") {
              status_class = "is-warning";
              status_icon = "fa fa-clock-o";
            } else if (row.status === "processed") {
              status_class = "is-success";
              status_icon = "fa fa-check";
            }

            return `<div class="title is-6 mb-0">${
              row.name || ""
            }<span class="tag ${status_class} ml-2"><span class="icon"><i class="${status_icon}"></i></span> <span>${v.$t(
              row.status
            )}</span></div>
            `;
          },
        },
        {
          title: v.$t("period"),
          data: (row) => {
            // return `<div class="subtitle is-6 mb-0">
            //           <span class="icon"><i class="fa fa-calendar has-text-primary"></i></span>
            //           ${row.from_date || ""}
            //         </div>
            // <div class="subtitle is-6"><span class="icon"><i class="fa fa-calendar has-text-danger"></i></span> ${
            //   row.to_date || ""
            // }</div>`;
            return `<span class="icon"><i class="fa fa-calendar has-text-primary"></i></span>
                    ${format_date(row.from_date) || ""} - 
                    <span class="icon"><i class="fa fa-calendar has-text-warning"></i></span>
                    ${format_date(row.to_date) || ""}`;
          },
        },
        {
          title: v.$t("options"),
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.payroll_modal.edit(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("view"),
                icon: "fa fa-eye",
                icon_class: "is-small has-text-info",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.payroll_detail_modal.open(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete payroll?"),
                    v,
                    () => {
                      del("/staff/payroll", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    // format_date_time,
    create() {
      let v = this;
      v.$refs.payroll_modal.open();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
